/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { CreateHubModalEntrypointProps } from './CreateHubModal.entrypoint.types.tsx';

type CreateHubModalEntryPointComponent = EntryPointComponent<
	{},
	{},
	CreateHubModalEntrypointProps,
	{}
>;

export const createHubModalEntryPoint: EntryPoint<CreateHubModalEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CreateHubModalEntryPointComponent>(
			/* webpackChunkName: "async-service-hubs-create-hub-modal" */ './CreateHubModalEntryPoint.tsx',
		),
		getPreloadProps: () => ({}),
	});
